//===================考试倒计时===============

const timer = {

  state: {
    //定时器函数，方便清空
    timeFuc : null,
    //默认十小时 ，单位：秒
    countdown : 36000,
    timeStr : '00:00:00',
  },

  mutations: {
    SET_TIMER(state,payload){
      state.countdown = payload;
    },
    //开始计时
    START_TIMER(state){
      if(!state.timeFuc){
        state.timeFuc = setInterval(()=>{
          state.countdown -= 1;
        },1000)
      }
    },

    //停止计时
    STOP_TIMER(state){
      clearInterval(state.timeFuc);
      state.timeFuc = null;
    },

  },

};

export default timer;
